export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-white">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-fire-line text-white text-lg"></i>
              </span>
              <span className="font-heading text-lg text-white">51今日吃瓜</span>
            </div>
            <p className="text-sm text-white/60 leading-relaxed">
              51吃瓜网今日吃瓜资源每日更新，提供51吃瓜官网全网最新资讯。娱乐圈爆料、网红真相、今日热门瓜，吃瓜速报一网打尽，51吃瓜群众每日最新瓜速递。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-white mb-4">快速导航</h4>
            <div className="space-y-2">
              <a href="#updates" className="block text-sm text-white/60 hover:text-white transition-colors cursor-pointer">吃瓜速报</a>
              <a href="#topics" className="block text-sm text-white/60 hover:text-white transition-colors cursor-pointer">热门话题</a>
              <a href="#cards" className="block text-sm text-white/60 hover:text-white transition-colors cursor-pointer">深度吃瓜</a>
              <a href="#ranking" className="block text-sm text-white/60 hover:text-white transition-colors cursor-pointer">热度榜</a>
              <a href="#carousel" className="block text-sm text-white/60 hover:text-white transition-colors cursor-pointer">焦点专题</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-white mb-4">内容分类</h4>
            <div className="space-y-2">
              <a href="#index" className="block text-sm text-white/60 hover:text-white transition-colors cursor-pointer">娱乐圈爆料</a>
              <a href="#index" className="block text-sm text-white/60 hover:text-white transition-colors cursor-pointer">网红真相</a>
              <a href="#index" className="block text-sm text-white/60 hover:text-white transition-colors cursor-pointer">综艺八卦</a>
              <a href="#index" className="block text-sm text-white/60 hover:text-white transition-colors cursor-pointer">剧组内幕</a>
              <a href="#index" className="block text-sm text-white/60 hover:text-white transition-colors cursor-pointer">品牌代言</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-white mb-4">合作伙伴</h4>
            <p className="text-sm text-white/40 leading-relaxed">
              更多合作伙伴信息即将揭晓，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            &copy; 2026 51今日吃瓜. 本站内容仅供娱乐，请理性吃瓜。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-white/40 hover:text-white/70 transition-colors cursor-pointer">关于我们</a>
            <a href="#contact" className="text-xs text-white/40 hover:text-white/70 transition-colors cursor-pointer">联系我们</a>
            <a href="#faq" className="text-xs text-white/40 hover:text-white/70 transition-colors cursor-pointer">常见问题</a>
          </div>
        </div>
      </div>
    </footer>
  );
}